import { apiHolder, apis, conf, inWindow, locationHelper, } from 'api';
import dayjs from 'dayjs';
import { getIn18Text } from 'api';
import { getLingXiEntryHost } from '@web-common/utils/utils';
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const contextPath = conf('contextPath');
export const formatAuthTexts = (roleInfos) => {
    if (!Array.isArray(roleInfos)) {
        return ['Master'];
    }
    if (!roleInfos.length) {
        return ['Empty'];
    }
    const roleList = roleInfos.map(item => item.roleName);
    return roleList.join('/').split('/');
};
export const computeAuthWeight = (authList, language) => {
    let authMap = new Map();
    if (language === 'ch') {
        authMap = new Map([
            ['查看', 0],
            ['管理', 2 + 1],
            ['上传', 1],
            ['下载', 0],
            ['Master', 4 + 2 + 1],
            ['Empty', 0],
        ]);
    }
    else {
        authMap = new Map([
            [getIn18Text('CHAKAN'), 0],
            [getIn18Text('GUANLI'), 2 + 1],
            [getIn18Text('SHANGCHUAN'), 1],
            [getIn18Text('XIAZAI'), 0],
            ['Master', 4 + 2 + 1],
            ['Empty', 0],
        ]);
    }
    const weightValue = authList.reduce((total, cur) => {
        const curWeight = authMap.has(cur) ? authMap.get(cur) : 0;
        return total | curWeight;
    }, 0);
    return weightValue;
};
export const checkActionAuth = (item, action) => {
    var _a;
    const isDir = item.extensionType === 'dir';
    if ((item === null || item === void 0 ? void 0 : item.authorityDetail) === null)
        return true;
    const privileges = ((_a = item === null || item === void 0 ? void 0 : item.authorityDetail) === null || _a === void 0 ? void 0 : _a.privilegeInfos) || (item === null || item === void 0 ? void 0 : item.roles);
    if (action == 'detail')
        return (privileges === null || privileges === void 0 ? void 0 : privileges.length) > 0;
    const hasAuth = privileges === null || privileges === void 0 ? void 0 : privileges.some(({ privilegeName }) => {
        switch (action) {
            case 'rename':
                return isDir ? privilegeName === '重命名文件夹' : privilegeName === getIn18Text('ZHONGMINGMINGWENJIAN');
            case 'download':
                return isDir ? false : privilegeName === getIn18Text('XIAZAI');
            default:
                return false;
        }
    });
    return hasAuth;
};
export const DEFAULT_AUTHORITY = {
    text: '',
    has: () => false,
};
export const formatAuthority = (roleInfos, type, mode = '') => {
    if (!Array.isArray(roleInfos)) {
        return DEFAULT_AUTHORITY;
    }
    const resAry = roleInfos
        .reduce((pre, cur) => {
        let item = cur.roleName;
        if (item === '管理') {
            item = mode == 'simple' ? '管理者' : '查看/上传/下载/编辑/管理';
        }
        if (item === '编辑') {
            item = mode == 'simple' ? '可编辑' : '查看/上传/下载/编辑';
        }
        return pre.concat(item.split('/'));
    }, [])
        .filter((item) => {
        if (type && type !== 'dir' && item === '上传') {
            return false;
        }
        return true;
    });
    if (resAry.some((item) => item === '下载')) {
        resAry.unshift('查看');
    }
    const uniqueAry = [...new Set(resAry)];
    const text = uniqueAry
        .map((key) => {
        switch (key) {
            case '查看':
                return getIn18Text('CHAKAN');
            case '上传':
                return getIn18Text('SHANGCHUAN');
            case '下载':
                return getIn18Text('XIAZAI');
            case '编辑':
                return getIn18Text('BIANJI');
            case '管理':
                return getIn18Text('GUANLI');
            case '管理者':
                return getIn18Text('GUANLIZHE');
            case '可编辑':
                return getIn18Text('KEBIANJI');
            default:
                return key;
        }
    })
        .join('/');
    return {
        text,
        has: (key) => uniqueAry.some(item => item.includes(key)),
    };
};
export const calcPrivilege = (roleInfos) => {
    if (!Array.isArray(roleInfos))
        return getIn18Text('KECHAKAN');
    const roleNames = roleInfos.map(item => item.roleName);
    if (roleNames.includes('管理')) {
        return getIn18Text('GUANLIZHE');
    }
    if (roleNames.includes('编辑')) {
        return getIn18Text('KEBIANJI');
    }
    if ((roleNames.includes('上传') && roleNames.includes('下载')) || roleNames.includes('上传/下载')) {
        return getIn18Text('KECHAKAN/SHANG');
    }
    if (roleNames.includes('上传')) {
        return getIn18Text('KESHANGCHUAN');
    }
    if (roleNames.includes('下载')) {
        return getIn18Text('KECHAKAN/XIA');
    }
    return getIn18Text('KECHAKAN');
};
export const timeFormatTwo = (date, useServerTimeZone) => {
    if (!date)
        return '';
    if (typeof date === 'string')
        date = date.replace(/-/g, '/');
    const timeZone = mailConfApi.getTimezone();
    const formdate = new Date(systemApi.getDateByTimeZone(date, timeZone, useServerTimeZone));
    const hours = formdate.getHours() % 12;
    const hoursText = formdate.getHours() > 12 ? getIn18Text('XIAWU') : getIn18Text('SHANGWU');
    const minutes = formdate.getMinutes() > 9 ? formdate.getMinutes() : '0' + formdate.getMinutes();
    return `${formdate.getFullYear()}年${formdate.getMonth() + 1}月${formdate.getDate()}日 ${hoursText}${hours || 12}:${minutes}`;
};
export const getTrail = name => {
    if (!name)
        return '';
    const splitName = name.split('.');
    if (splitName.length > 1) {
        return splitName[splitName.length - 1];
    }
    return getIn18Text('WEIZHI');
};
export const normalizeShareUrl = (url) => (url.indexOf('http') === 0 ? url : `https://${url}`);
export const getFileType = (file) => {
    if (file.fileType === 'excel') {
        return getIn18Text('XIETONGBIAOGE');
    }
    if (file.fileType === 'doc') {
        return getIn18Text('XIETONGWENDANG');
    }
    if (file.fileType === 'unitable') {
        return 'Unitable';
    }
    return getTrail(file.name).toUpperCase();
};
export const isImage = (file) => {
    var _a;
    let _isImage = false;
    switch ((_a = file.extensionType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) {
        case 'jpeg':
        case 'jpg':
        case 'png':
        case 'gif':
            _isImage = true;
            break;
    }
    return _isImage;
};
export const getFileIcon = (file) => {
    const { name, fileName, fileType } = file;
    const theName = name || fileName;
    if (fileType === 'excel') {
        return 'lxxls';
    }
    if (fileType === 'doc') {
        return 'lxdoc';
    }
    if (fileType === 'unitable') {
        return 'lxunitable';
    }
    return getTrail(theName).toLowerCase();
};
export const getShareLink = (item) => {
    const host = window && window.electronLib ? conf('host') : `https://${locationHelper.getHost()}` || 'https://su-desktop-web.cowork.netease.com:8000';
    const isDir = item.resourceType === 'DIRECTORY';
    return host + contextPath + `/share_anonymous/#type=${item.resourceType}&shareIdentity=${item.shareIdentity}&${isDir ? 'dirId' : 'fileId'}=${item.resourceId}`;
};
export const sendShareLinkMail = (item) => {
    const link = getShareLink(item);
    const { resourceName, shareTime, validPeriod } = item;
    let validPeriodDate = '';
    if (validPeriod.intervalType === 'RELATIVE') {
        if (validPeriod.period === -1) {
            validPeriodDate = getIn18Text('YONGJIU');
        }
        else {
            validPeriodDate = validPeriod.period + getIn18Text('TIAN');
        }
    }
    else {
        validPeriodDate = simpleFormatTime(validPeriod.interval.startTime, true) + '-' + simpleFormatTime(validPeriod.interval.endTime, true);
    }
    mailApi.callWriteLetterFunc({
        mailType: 'common',
        withoutPlaceholder: true,
        writeType: 'common',
        originContent: `<p>分享资料：${resourceName}</p><p>分享时间：${simpleFormatTime(shareTime)}</p><p>有效期：${validPeriodDate}</p><p>分享链接：<a href=${link} target="_blank">${link}</a></p>`,
    });
};
export const simpleFormatTime = (time, endOfDay, useServerTimezone) => {
    const timeZone = mailConfApi.getTimezone();
    const now = dayjs(systemApi.getDateByTimeZone(new Date(), timeZone));
    const _time = time ? systemApi.getDateByTimeZone(time, timeZone, useServerTimezone) : time;
    const timeDayjs = dayjs(_time);
    const sameYear = now.year() === timeDayjs.year();
    return dayjs(_time).format(`${sameYear ? getIn18Text('MYUEDRI') : getIn18Text('YYYYNIAN')}${endOfDay ? '' : ` ${timeDayjs.format('A') === 'PM' ? getIn18Text('XIAWU') : getIn18Text('SHANGWU')}h:mm`}`);
};
export const remainderDateFormat = (startTime, endTime) => {
    try {
        const timeZone = mailConfApi.getTimezone();
        const _endTime = dayjs(systemApi.getDateByTimeZone(endTime, timeZone));
        const _startTime = dayjs(systemApi.getDateByTimeZone(startTime, timeZone));
        const days = _endTime.diff(_startTime, 'd');
        const hours = _endTime.diff(_startTime, 'h');
        const minutes = _endTime.diff(_startTime, 'm');
        const seconds = _endTime.diff(_startTime, 's');
        let res = days >= 1 ? `${days}` + getIn18Text('TIAN') : '';
        res += hours % 24 >= 1 ? `${hours % 24}` + getIn18Text('XIAOSHI') : '';
        res += minutes % 60 >= 1 && days < 1 ? `${minutes % 60}` + getIn18Text('FENZHONG') : '';
        res += seconds < 60 ? `${seconds}` + getIn18Text('MIAO') : '';
        return res;
    }
    catch (error) {
        return '';
    }
};
export const CONVERT_MAX_SIZE = inWindow() && window.navigator.userAgent.match(/windows nt/i) ? 200 * 1024 * 1024 : 200 * 1000 * 1000;
export const MB_SIZE = inWindow() && window.navigator.userAgent.match(/windows nt/i) ? 1024 * 1024 : 1000 * 1000;
export function getConvertFileType(fileType) {
    if (fileType === 'docx') {
        return 'doc';
    }
    if (['xls', 'xlsx', 'csv'].includes(fileType)) {
        return 'sheet';
    }
    return '';
}
export const edmJump = (shareUrl) => {
    const curUserInfo = systemApi.getCurrentUser();
    if (!curUserInfo) {
        systemApi.openNewWindow(shareUrl);
        return;
    }
    let toUrl = encodeURIComponent(shareUrl);
    let fromUrl = encodeURIComponent(window.location.href);
    const search = `toUrl=${toUrl}&jumpType=0&jumpMode=jumpOut&sid=${curUserInfo.sessionId}&uid=${curUserInfo.id}&fromUrl=${fromUrl}`;
    const jumpUrl = getLingXiEntryHost() + 'jump/?' + search;
    console.log('jumpUrl', jumpUrl, curUserInfo);
    systemApi.openNewWindow(jumpUrl);
};
